export default __webpack_public_path__ + "static/media/CheesePotato.51e46edf.png";